import axios from "axios";
import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";

export const createServiceUser = async (data: any) => {
  const res = await axios({
    method: "POST",
    url:`${SERVER_URL}/user/register`,
    data,
  });

  return res.data;
};
export const loginService = async (data: any) => {
  
  return await HttpRequest.post(`${SERVER_URL}/user/login`, data);
};

export const profileService = async (token: String) => {
  return await HttpRequest.get(`${SERVER_URL}/user/profile`);

};

export const userProfileBasicService = async (email: String) => {
  return await HttpRequest.get(`${SERVER_URL}/user/userInfo/${email}`);

};

export const updateServiceUser = async (itemId: string,data: any,token: string) => {
  return await HttpRequest.update(`${SERVER_URL}/user/one/${itemId}`,data,token);
};
